module.exports = __webpack_public_path__ + "img/question-icon-4.c8317936.png";